import { computed, ref } from "vue";
import { chairTL } from "../generated/tl";
import type { ChairListItemDto } from "../types/chair";
import { chairLabel } from "../services/chairLabel";

/**
 * Seznam organizačních pozic (Chair) pro výběr hodnoty parametru typu chair/chairMulti (docs/tasks/057.md).
 * `ChairTL::findChairs()` je čtení bez zvláštního oprávnění, takže funguje i pro běžné uživatele.
 * Načte se jednou na celou session (module-level cache); `reloadChairs()` ho obnoví.
 */
const chairs = ref<ChairListItemDto[] | null>(null);
let loading: Promise<void> | null = null;

export const reloadChairs = async (): Promise<void> => {
	chairs.value = await chairTL.findChairs();
};

export function useChairs() {
	if (chairs.value === null && loading === null) {
		loading = reloadChairs().catch(() => { chairs.value = []; }).finally(() => { loading = null; });
	}

	const items = computed<ChairListItemDto[]>(() => chairs.value ?? []);
	const labelById = (id: number | null | undefined): string => {
		if (id == null) return '';
		const item = chairs.value?.find(c => c.chair.id === id);
		return item ? chairLabel(item) : `#${id}`;
	};

	return { chairs: items, labelById };
}
